import { ApplicationState } from '../../../../reducers'
import { FieldProps, MethodProps, Notifications } from './Notifications'
import { connect } from 'react-redux'
import { isNotificationAreaShownSelector, notificationCountSelector, sortedNotificationListSelector } from './reducer'
import { showNotificationArea } from './actions'
import { hideNotifications } from './thunks'

const mapStateToProps = (state: ApplicationState): FieldProps => ({
    notificationsShown: isNotificationAreaShownSelector(state),
    notificationCount: notificationCountSelector(state),
    notifications: sortedNotificationListSelector(state),
})

const actions: MethodProps = {
    showNotificationArea,
    hideNotificationArea: hideNotifications,
}

const NotificationsWithData = connect(mapStateToProps, actions)(Notifications)

export { NotificationsWithData }
